<template>
  <div class="header">
    <div class="header-img" @click="menuSidebar = !menuSidebar">
<!--      <img src="@/assets/photo/header.png">-->
      <i :class="headerIconClass"></i>
    </div>
    <div class="sys-title">
      {{sysTitle}}
      <span class="sys-version">{{sysVer}}</span>
    </div>
    <div class="header-right">
      <div class="header-search" v-if="userHomePage == 'HomePage'">
        <el-input size="mini" :placeholder="$t('common.pleaseEnterContent')" v-model="searchStr" class="input-with-select" @keyup.native.enter="QueryAll">
          <el-button size="mini" type="info" slot="append" icon="el-icon-search" @click="QueryAll"></el-button>
          <el-select size="mini" v-model="qtype" slot="prepend" class="input-with-select-pre" :placeholder="$t('common.pleaseSelect')">
            <el-option :label="$t('main.Header.all')" value="A"></el-option>
            <el-option :label="$t('main.Header.receipt')" value="D"></el-option>
            <el-option :label="$t('main.Header.file')" value="F"></el-option>
            <el-option :label="$t('main.Header.productInformation')" value="B"></el-option>
          </el-select>
        </el-input>
      </div>
      <div class="header-infos">
        <el-popover placement="bottom" width="90" trigger="hover">
          <el-table :data="userqdMnData" :show-header="false" max-height="200px">
            <el-table-column width="20" property="r_icon_class" :label="$t('main.Header.headerInformation')">
              <template slot-scope="scope">
                <i :class="scope.row.r_icon_class"></i>
              </template>
            </el-table-column>
            <el-table-column width="90" property="r_mn_desc" :label="$t('main.Header.menuName')">
              <template slot-scope="scope">
                <mh-link :src="scope.row.r_mn_id" mType="link" :content="scope.row.r_mn_desc" :mNbr="scope.row.r_mn_id" mClass="MhLinkBlack"></mh-link>
              </template>
            </el-table-column>
            <el-table-column width="60" property="userqd_ucode" :label="$t('main.Header.shortCode')" sortable show-tooltip-when-overflow></el-table-column>
            <el-table-column width="40" property="r_mn_id" :label="$t('main.Header.operation')">
              <template slot-scope="scope">
                <i class="el-icon-edit uinfoMore" style="float: left" @click="openUserqd(scope.row)"></i>
                <i class="el-icon-minus uinfoMore" style="float: right"  @click="minusUserqdMn(scope.row.r_mn_id)"></i>
              </template>
            </el-table-column>
          </el-table>
          <div slot="reference" style="margin-top: 5px;position: absolute;cursor: pointer" onmouseover="infosListId.style.color='#8cc5ff';" onmouseout="infosListId.style.color='#38393c'">
            <i id="infosListId" class="el-icon-finished" style="font-size: 20px"></i>
          </div>
          <div @click="openUserqdMn" class="uinfoMore" onmouseover="infosMoreId.style.color='#8cc5ff';" onmouseout="infosMoreId.style.color='#38393c'">
            <el-button id="infosMoreId" type="text" size="mini" icon="el-icon-plus">{{$t('main.Header.shortcutMenu')}}</el-button>
          </div>
        </el-popover>
      </div>
      <div class="header-uinfo">
        <el-badge :value="UutkMstr.r_uinfo_qty" :max="10">
          <el-popover placement="bottom" width="200" trigger="hover">
            <el-table :data="UinfoHist" :show-header="false" @row-click="uinfoDataDbClick" :cell-style="cellStyle" max-height="200px">
              <el-table-column width="200" property="uinfoTitle" :label="$t('main.Header.headerInformation')" show-tooltip-when-overflow></el-table-column>
            </el-table>
            <div slot="reference" class="uinfoList" onmouseover="uinfoListId.style.color='#8cc5ff';" onmouseout="uinfoListId.style.color='#38393c'">
              <i id="uinfoListId" class="el-icon-chat-dot-square" style="font-size: 20px"></i>
            </div>
            <div @click="uinfoHistRouter" class="uinfoMore" onmouseover="uinfoMoreId.style.color='#8cc5ff';" onmouseout="uinfoMoreId.style.color='#38393c'">
              <el-button id="uinfoMoreId" type="text" size="mini" icon="el-icon-more">{{$t('main.Header.viewMore')}}</el-button>
            </div>
          </el-popover>
        </el-badge>
      </div>
      <div class="header-uutk" v-if="userHomePage == 'HomePage'">
        <el-badge :value="UutkMstr.r_wappr_qty" type="primary">
          <div class="ListIdClass" @click="uutkMstrRouter" onmouseover="uutkListId.style.color='#8cc5ff';" onmouseout="uutkListId.style.color='#38393c'">
            <i id="uutkListId" class="el-icon-document-copy" style="font-size: 20px"></i>
          </div>
        </el-badge>
      </div>
      <div class="header-efile" v-if="userHomePage == 'HomePage'">
        <el-badge :value="UutkMstr.r_efile_qty" type="primary">
          <div class="ListIdClass" @click="efilePublishDetRouter" onmouseover="efileListId.style.color='#8cc5ff';" onmouseout="efileListId.style.color='#38393c'">
            <i id="efileListId" class="el-icon-folder-checked" style="font-size: 20px"></i>
          </div>
        </el-badge>
      </div>
      <div class="header-wxMsg" v-if="userHomePage == 'HomePage'">
        <el-badge>
          <div class="ListIdClass" @click="wxSend" onmouseover="wxMsgId.style.color='#8cc5ff';" onmouseout="wxMsgId.style.color='#38393c'">
            <i id="wxMsgId" class="el-icon-s-comment" style="font-size: 20px"></i>
          </div>
        </el-badge>
      </div>
      <div class="header-message" @click="userWx = false">
        <el-popover placement="bottom-end" trigger="manual" v-model="userWx">
          <span style="color: #fc8c23">{{contentWx}}</span>
          <mh-link slot="reference" :mNbr="userInfo.message" src="USERINFO" :content="userInfo.message" :mObj="userInfo"></mh-link>
        </el-popover>
      </div>
      <div class="header-out" @click="loginOut">
        <el-button icon="el-icon-switch-button" circle size="mini"></el-button>
      </div>
    </div>

    <el-dialog :title="$t('main.Header.wechatMessage')" :visible.sync="userWxDlg" :close-on-click-modal="false"
               :modal-append-to-body=false width="50%">
      <span slot="title" style="font-size: 10px;">{{$t('main.Header.wechatMessage')}}<i class="el-icon-s-comment"></i></span>
      <el-form :model="userWxObj" label-position="right" label-width="90px" size="mini" :rules="userWxFormRules" ref="userWxFormRef">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('main.Header.receiver')" prop="userCode">
              <el-select v-model="userWxObj.userCode" multiple filterable  @change="userCodeChange">
                <el-option v-for="item in userCodeList"
                          :key="item.userCode"
                          :label="item.userName"
                          :value="item.userEmp">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('main.Header.infoContent')" prop="userMsg" >
              <el-input type="textarea" rows="8" v-model="userWxObj.userMsg"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="userWxDlg = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" size="mini" @click="userWxSendConfirm">{{$t('main.Header.send')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('main.Header.userMenu')" :visible.sync="showAddUserqdDlg" :close-on-click-modal="false"
               :modal-append-to-body=false width="60%" class="makeDocDlgClass" ref="addUserqdDlg">
      <div>
        <el-table :data="userMnData" height="300"
                  ref="userMnTable" :row-class-name="rowClassName">
          <el-table-column type="index" v-if="1===0"></el-table-column>
          <el-table-column prop="r_icon_class" label="-" width="60" align="center">
            <template slot-scope="scope">
              <div>
                <i :class="scope.row.r_icon_class"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="r_mn_desc" :label="$t('main.Header.menuName')" width="170"></el-table-column>
          <el-table-column prop="r_ucode" :label="$t('main.Header.shortCode')" width="170"></el-table-column>
          <el-table-column prop="r_mn_id" :label="$t('main.Header.operation')" width="80" align="center">
            <template slot-scope="scope">
              <div>
                <i class="el-icon-plus minusUserMnClass" @click="chkUserqdDetData('insert', scope.row)"></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :title="$t('main.Header.customMenuQuery')" :visible.sync="showUserqdUcode" :close-on-click-modal="false"
               :modal-append-to-body=false width="500px">
      <span slot="title" style="font-size: 10px;">{{$t('main.Header.customMenuQuery')}}<i class="el-icon-menu"></i></span>
      <el-form :model="UserqdObj" label-position="right" label-width="90px" size="mini" ref="userWxFormRef">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('main.Header.menuName')" prop="desc">
              <el-input v-model="UserqdObj.desc" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('main.Header.customQuery')" prop="userqdUcode" >
              <el-input v-model="UserqdObj.userqdUcode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showUserqdUcode = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" size="mini" @click="chkUserqdDetData('update')">{{$t('common.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MhLink from '@/components/base/MhLink.vue'
import axios from 'axios'
import i18n from '@/i18n'
export default {
  data () {
    return {
      headerIconClass: 'el-icon-s-unfold',
      menuSidebar: false,
      userWx: false,
      contentWx: '',
      qtype: 'A',
      sysTitle: '',
      sysVer: '',
      searchStr: '',
      userInfo: {
        message: window.sessionStorage.getItem('currentUserName')
      },
      uinfoDataObj: {},
      userWxDlg: false,
      userWxObj: {
        userCode: '',
        userMsg: ''
      },
      userWxSend: {
        touser: '',
        todepart: '',
        totag: '',
        content: '',
        msgType: ''
      },
      userCodeList: {},
      userWxFormRules: {
        userCode: [
          { required: true, message: i18n.t('main.Header.recipientNotEmpty'), trigger: 'blur' }
        ],
        userMsg: [
          { required: true, message: i18n.t('main.Header.mesContentNotEmpty'), trigger: 'blur' }
        ]
      },
      userqdMnData: [],
      userMnData: [],
      showAddUserqdDlg: false,
      showUserqdUcode: false,
      UserqdObj: {
        desc: '',
        userqdMenu: '',
        userqdUcode: ''
      }
    }
  },
  computed: {
    ...mapGetters('AppInfo', ['UutkMstr', 'UinfoHist']),
    ...mapGetters('cacheTabs', ['userHomePage'])
  },
  methods: {
    ...mapActions('dynamicRouter', ['addMenuRouters']),
    ...mapMutations('cacheTabs', ['clearTabList']),
    ...mapMutations('queryAll', ['setCondition', 'setQtype']),
    ...mapActions('AppInfo', ['loadAppInfoUser']),
    ...mapMutations('AppInfo', ['loadUutkMstrInfo', 'loadUinfoHist']),
    loginOut: function () {
      const that = this
      that.$confirm(i18n.t('main.Header.exitSystem'), i18n.t('common.pleaseConfirm'), {
        confirmButtonText: i18n.t('common.confirm'),
        cancelButtonText: i18n.t('common.cancel'),
        type: 'warning'
      }).then(() => {
        // window.sessionStorage.removeItem('currentSite')
        // window.sessionStorage.removeItem('defApp')
        // window.sessionStorage.removeItem('currentUserCode')
        // window.sessionStorage.removeItem('currentUser')
        // window.sessionStorage.removeItem('token')
        // window.sessionStorage.removeItem('tabsItem')
        // window.sessionStorage.removeItem('dyanmicRouters')
        window.sessionStorage.clear()
        that.addMenuRouters([])
        that.clearTabList()
        that.$router.push('/login')
        // that.$router.replace('/login')
        // location.reload()
      }).catch(() => {})
    },
    loadSysTitle: async function () {
      const that = this
      const para = {}
      const para2 = {}
      const lang = localStorage.getItem('lang')
      if (that.userHomePage === 'ScmHomePage') {
        para.sysCode = 'SYSCFG'
        para.sysField = 'sys_char5'
        para2.sysCode = 'SYSCFG'
        para2.sysField = 'sys_char6'
        if (lang === 'en') {
          para.sysField = 'sys_char9'
        } else if (lang === 'zh_TW') {
          para.sysField = 'sys_char10'
        }
      } else {
        para.sysCode = 'SYSCFG'
        para.sysField = 'sys_char1'
        para2.sysCode = 'SYSCFG'
        para2.sysField = 'sys_char2'
        if (lang === 'en') {
          para.sysField = 'sys_char7'
        } else if (lang === 'zh_TW') {
          para.sysField = 'sys_char8'
        }
      }
      const { data: ress } = await axios.post('/users/selectValueByField', para)
      that.sysTitle = ress.data
      const { data: res } = await axios.post('/users/selectValueByField', para2)
      that.sysVer = res.data
    },
    //  打开用户消息uinfoHist页面
    uinfoHistRouter: async function () {
      const that = this
      const src = '460'
      const para = {}
      para.id = src
      await that.$router.push({
        name: src,
        params: para
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {})
    },
    //  消息表格样式
    cellStyle: function ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          color: '#2e317c',
          textDecoration: 'underline',
          cursor: 'pointer'
        }
      }
    },
    //  消息表格点击事件
    uinfoDataDbClick: async function (row) {
      const that = this
      if (row.uinfoNbr.slice(0, 4) === 'UUTK') {
        const para = {}
        para.condition = [{
          qJoin: 'and',
          qField: 'uutk_nbr',
          qOp: '=',
          qValue: row.uinfoNbr,
          qType: 'string'
        }]
        para.pageNo = 1
        para.pageNum = 10
        const { data: res } = await this.$http.post('/tk/getListApprUutkMstr', para)
        if (res.data.list[0]) {
          that.uinfoDataObj = res.data.list[0]
          const index = that.uinfoDataObj.uutkTypeUrl
          const nbr = that.uinfoDataObj.uutkNbr
          that.uinfoDataObj.id = index
          that.$router.params = that.uinfoDataObj
          const stl = await that.$Any.getStaticRouterUrl(that.uinfoDataObj.uutkTypeUrl, nbr)
          this.$Any.pushRouter(that.$router, stl, nbr, that.uinfoDataObj)
        } else {
          that.$message({
            type: 'warning',
            message: i18n.t('main.Header.auditNotExist')
          })
        }
      } else {
        const stl = await that.$Any.getStaticRouterUrl(row.uinfoUrl, row.uinfoNbr)
        const para = {}
        para.id = row.uinfoUrl
        para.nbr = row.uinfoNbr
        para.lot = ''
        para.code = ''
        that.$Any.pushRouter(that.$router, stl, row.uinfoNbr, para)
      }
    },
    //  打开待审核单据uutkMstr页面
    uutkMstrRouter: async function () {
      const that = this
      const src = '400'
      const para = {}
      para.id = src
      await that.$router.push({
        name: src,
        params: para
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {})
    },
    //  打开文件签收页面
    efilePublishDetRouter: async function () {
      const that = this
      const src = '440'
      const para = {}
      para.id = src
      await that.$router.push({
        name: src,
        params: para
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {})
    },
    QueryAll: async function () {
      const that = this
      if (that.searchStr === '') {
        that.$alert(i18n.t('main.Header.searchNotEmpty'), i18n.t('common.tips'), {
          confirmButtonText: i18n.t('common.confirm')
        })
      } else {
        const mnPara = {
          user: that.$Any.getCurrentUser(),
          condition: that.searchStr
        }
        const { data: res } = await this.$http.post('/users/getMnQuery', mnPara)
        if (res.data[0]) {
          const src = res.data[0].mn_id
          const para = {}
          para.id = src
          await that.$router.push({
            name: src,
            params: para
            // eslint-disable-next-line handle-callback-err
          }).catch(err => {})
        } else {
          that.setCondition(that.searchStr)
          that.setQtype(that.qtype)
          if (that.qtype === 'B') {
            const stl = await that.$Any.getStaticRouterUrl('PARTINFO', 'PARTINFO')
            const para = {}
            para.part = that.searchStr
            // para.site = 'DGERP'
            that.$Any.pushRouter(that.$router, stl, 'PARTINFO', para)
          } else {
            const stl = await that.$Any.getStaticRouterUrl('QUERYALL', 'QUERYALL')
            const para = {}
            para.id = that.src
            para.condition = that.searchStr
            para.qtype = that.qtype
            para.nbr = 'QUERYALL'
            para.lot = ''
            para.code = ''
            that.$Any.pushRouter(that.$router, stl, 'QUERYALL', para)
          }
        }
      }
    },
    // 微信消息界面
    wxSend: function () {
      const that = this
      that.userWxDlg = true
      that.loadSelectOptions()
      that.$nextTick(() => {
        that.$refs.userWxFormRef.resetFields()
      })
    },
    // 消息接收人
    userCodeChange: function (val) {
      const that = this
      that.userWxSend.touser = ''
      val.forEach(emp => {
        that.userWxSend.touser = that.userWxSend.touser + emp + '|'
      })
    },
    // 确认发送微信消息
    userWxSendConfirm: async function () {
      const that = this
      that.$refs.userWxFormRef.validate(async valid => {
        if (!valid) {
          return
        }
        that.userWxSend.content = that.userWxObj.userMsg + '（' + i18n.t('main.Header.sender') + window.sessionStorage.getItem('currentUserName') + '）'
        that.userWxSend.msgType = 'text'
        const { data: res } = await that.$http.post('/users/sendWeixinMsg', that.userWxSend)
        if (res.data.errcode === 0) {
          that.userWxDlg = false
        } else {
          that.$message({
            showClose: true,
            type: 'warning',
            message: i18n.t('main.Header.mesSendFail')
          })
        }
      })
    },
    //  加载微信消息接收人下拉列表数据
    loadSelectOptions: async function () {
      const that = this
      that.$Any.getMapkvOptions('USERALLWX').then(function (list) {
        that.userCodeList = list.options
      })
    },
    // 判断用户是否加入了企业微信
    getUserIdWx: async function () {
      if (window.sessionStorage.getItem('currentUserEmp') === '') {
        this.contentWx = i18n.t('main.Header.canNotUseWechat')
        this.userWx = true
      } else {
        const para = {}
        para.userEmp = window.sessionStorage.getItem('currentUserEmp')
        const { data: resEmp } = await this.$http.post('/users/getUserWx', para)
        if (resEmp.data.errcode !== 0) {
          this.contentWx = i18n.t('main.Header.pleaseConsultAdministrator')
          this.userWx = true
        }
      }
      setTimeout(() => {
        this.userWx = false
      }, 5000)
    },
    loadUserqdMnList: async function () {
      const that = this
      const para = {
        lang: that.$Any.getCurrentLang(),
        user: that.$Any.getCurrentUser(),
        type: 'Q',
        qry: ''
      }
      const { data: res } = await that.$http.post('/users/getUserqdAllMn', para)
      if (res.data) {
        that.userqdMnData = res.data
      }
    },
    loadUserMnList: async function () {
      const that = this
      const para = {
        lang: that.$Any.getCurrentLang(),
        user: that.$Any.getCurrentUser(),
        type: 'N',
        qry: ''
      }
      const { data: res } = await that.$http.post('/users/getUserqdAllMn', para)
      if (res.data) {
        that.userMnData = res.data
      }
    },
    rowClassName ({ row, rowIndex }) {
      // row.index = rowIndex
    },
    openUserqdMn: function () {
      const that = this
      that.loadUserMnList().then(function () {
        that.showAddUserqdDlg = true
      })
    },
    // 删除快捷菜单
    minusUserqdMn: async function (mnId) {
      const that = this
      const para = {
        action: 'delete',
        data: {
          userqdUser: that.$Any.getCurrentUser(),
          userqdMenu: mnId
        }
      }
      const { data: res } = await that.$http.post('/users/postUserqdDet', para)
      if (res === 1) {
        that.loadUserqdMnList()
      }
    },
    // 自定义查询编辑页面
    openUserqd: function (row) {
      const that = this
      that.showUserqdUcode = true
      that.UserqdObj.desc = row.r_mn_desc
      that.UserqdObj.userqdMenu = row.r_mn_id
      that.UserqdObj.userqdUcode = row.userqd_ucode
    },
    // 更改自定义查询
    updateUserqd: async function () {
      const that = this
      const para = {
        action: 'update',
        data: {
          userqdUser: that.$Any.getCurrentUser(),
          userqdMenu: that.UserqdObj.userqdMenu,
          userqdUcode: that.UserqdObj.userqdUcode
        }
      }
      const { data: res } = await that.$http.post('/users/postUserqdDet', para)
      if (res === 1) {
        that.showUserqdUcode = false
        await that.loadUserqdMnList()
      }
    },
    // 添加快捷菜单
    addUserqdMn: async function (row) {
      const that = this
      const para = {
        action: 'insert',
        data: {
          userqdUser: that.$Any.getCurrentUser(),
          userqdMenu: row.r_mn_id,
          userqdUcode: row.r_ucode
        }
      }
      const { data: res } = await that.$http.post('/users/postUserqdDet', para)
      if (res === 1) {
        that.showAddUserqdDlg = false
        await that.loadUserqdMnList()
      }
    },
    chkUserqdDetData: async function (action, row) {
      const that = this
      const a = {
        para: {
          '@code': {
            type: 'string',
            value: ''
          },
          '@lang': {
            type: 'string',
            value: 'zh_CN'
          },
          '@site': {
            type: 'string',
            value: ''
          },
          '@mnId': {
            type: 'string',
            value: ''
          },
          '@uuId': {
            type: 'string',
            value: this.uuId_
          },
          '@action': {
            type: 'string',
            value: action
          }
        },
        postChkUrl: '/users/execSqlChkProc_User',
        procName: 'UserqdDet_Chk'
      }
      if (action === 'insert') {
        a.para['@userqdUser'] = {
          type: 'string',
          value: that.$Any.getCurrentUser()
        }
        a.para['@userqdMenu'] = {
          type: 'string',
          value: row.r_mn_id
        }
        a.para['@userqdUcode'] = {
          type: 'string',
          value: row.r_ucode
        }
      } else {
        a.para['@userqdUser'] = {
          type: 'string',
          value: that.$Any.getCurrentUser()
        }
        a.para['@userqdMenu'] = {
          type: 'string',
          value: that.UserqdObj.userqdMenu
        }
        a.para['@userqdUcode'] = {
          type: 'string',
          value: that.UserqdObj.userqdUcode
        }
      }
      const url = '/users/execSqlChkProc_User'
      const { data: res } = await this.$http.post(url, a)
      if (res.flag === -1) {
        if (action === 'insert') {
          await that.addUserqdMn(row)
        } else {
          await that.updateUserqd()
        }
      } else {
        that.$alert(res.msg, i18n.t('common.tips'), {
          confirmButtonText: i18n.t('common.confirm')
        })
      }
    }
  },
  mounted () {
    if (document.body.clientWidth < 1500) {
      // this.collapseChage()
    }
    const that = this
    if (that.userHomePage === 'HomePage') {
      that.loadSelectOptions() // 微信接收人列表
      that.getUserIdWx() // 获取用户企业微信
      that.loadAppInfoUser({}) //  当前用户待审核单据等数量
    } else {
      that.loadUutkMstrInfo()
      that.loadUinfoHist()
    }
    that.loadSysTitle() //  左边标题信息
    that.loadUserqdMnList() // 快捷菜单
  },
  watch: {
    menuSidebar () {
      if (this.menuSidebar) {
        this.headerIconClass = 'el-icon-s-fold'
        document.getElementById('asideId').style.width = '60px'
        document.getElementById('sidebarId').style.width = '60px'
      } else {
        this.headerIconClass = 'el-icon-s-unfold'
        document.getElementById('asideId').style.width = '200px'
        document.getElementById('sidebarId').style.width = '200px'
      }
    },
    showUserqdUcode () {
      const that = this
      if (!that.showUserqdUcode) {
        that.UserqdObj.desc = ''
        that.UserqdObj.userqdMenu = ''
        that.UserqdObj.userqdUcode = ''
      }
    }
  },
  components: {
    MhLink
  }
}
</script>
<style lang="less" scoped>
  @-webkit-keyframes bganimation {
    0% {
      background-position: 0% 50%;
    }

    50% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0% 50%;
    }
  }
  .header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    font-size: 14px;
    border-bottom: 0px solid #eeeeee;
    background-image: linear-gradient(to right, #55abff, #FFFFFF);
    background-color: rgba(0,0,0,0.5);
    animation: bganimation 5s infinite;
    -webkit-animation:bganimation 5s infinite;
  }
  .header-img{
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 40px;
  }
  .header-message {
    padding-right: 15px;
    display: inline-block;
    height: 40px;
    align-items: center;
    color: #4e8afa;
  }
  .header-out {
    padding: 5px 15px;
    display: inline-block;
    height: 40px;
    align-items: center;
  }
  .header .sys-title {
    float: left;
    width: 350px;
    line-height: 40px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    color: whitesmoke;
  }
  .sys-version {
    font-style: italic;
    font-size: 12px;
  }
  .header-right {
    position: absolute;
    right: 1px;
    display: inline-block;
    white-space:nowrap;
  }
  .header-search {
    padding-right: 20px;
    display: inline-block;
    height: 40px;
    align-items: center;
  }
  .header-uinfo {
    padding-right: 20px;
    display: inline-block;
    height: 20px;
    align-items: center;
  }
  .uinfoList {
    padding: 0px 0px 0px 15px;
    display: inline-block;
    height: 20px;
    align-items: center;
    cursor: pointer;
  }
  .uinfoMore {
    cursor: pointer;
  }
  .header-uutk {
    padding-right: 20px;
    display: inline-block;
    height: 20px;
    align-items: center;
  }
  .ListIdClass {
    padding: 0px 0px 0px 0px;
    display: inline-block;
    height: 20px;
    align-items: center;
    cursor: pointer;
  }
  .input-with-select {
    width: 300px;
    color: blue;
  }
  .input-with-select-pre {
    width: 100px;
  }
  .header-efile {
    padding-right: 20px;
    display: inline-block;
    height: 20px;
    align-items: center;
  }
  .header-wxMsg {
    padding-right: 20px;
    display: inline-block;
    height: 20px;
    align-items: center;
  }
  .header-infos {
    padding-right: 20px;
    display: inline-block;
    height: 20px;
    align-items: center;
  }
</style>
